<script>
    // Importa el componente ProveedorView desde su respectiva ubicación
    import ProveedorView from "../../viewsERP/Proveedor.svelte";
</script>

<div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
        <ProveedorView />
    </div>
</div>
